<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { cardVariants } from '@/components/ui/variants';

const props = defineProps({
  as: { type: String, default: 'div' },
  to: { type: [String, Object], default: null },
  tone: { type: String, default: 'plain' },
  padding: { type: String, default: 'md' },
  radius: { type: String, default: 'lg' },
});

const tag = computed(() => (props.to ? RouterLink : props.as));
const classes = computed(() =>
  cardVariants({ tone: props.tone, padding: props.padding, radius: props.radius, interactive: Boolean(props.to) })
);
</script>

<template>
  <component :is="tag" :to="to ?? undefined" :class="classes">
    <slot />
  </component>
</template>
